import React from 'react';
import { Icon, IconProps } from './Icon';

export const CheckIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" {...props}>
      <path d="M20 6 9 17l-5-5" />
    </Icon>
  );
};
